import BootstrapField from '../utility/BootstrapField';
// import moment from 'moment-timezone';
// import CloneDeep from 'lodash.clonedeep';


// As private as it gets.
// let orgininalGlobalSettings = null;

export default class GlobalSettings {
	constructor(data) {
		if (!data) {
			data = {};
		}
		if (data.useTestData) {
			data = {}

		}

		Object.assign(this, {
			defaultContact: data.defaultContact || [],
			systemAccount: data.systemAccount || [],
			defaultTrafficSignalsContact: data.defaultTrafficSignalsContact || [],
			defaultTrafficServicesContact: data.defaultTrafficServicesContact || [],
			defaultEmergencyContact: data.defaultEmergencyContact || [],
			regionalFullClosureContact: data.regionalFullClosureContact || [],
			regionalClosureContact: data.regionalClosureContact || [],
			nonLocalFullClosureContact: data.nonLocalFullClosureContact || [],
			paintedBicycleClosureContact: data.paintedBicycleClosureContact || [],
			protectedBicycleClosureContact: data.protectedBicycleClosureContact || [],
			defaultApprover: data.defaultApprover || [],
			defaultParkingContact: data.defaultParkingContact || [],
			parkingRemovalContact: data.parkingRemovalContact || [],
			defaultTransitContact: data.defaultTransitContact || [],
			cancelledClosureContact: data.cancelledClosureContact || [],
			failedReopeningClosureContact: data.failedReopeningClosureContact || [],
			permitContact: data.permitContact || [],
			defaultDCZContact: data.defaultDCZContact || [],
		});

		// Keep a record of the old data. (used for the hasChanges() method)
		// orgininalGlobalSettings = CloneDeep(this);
	}

	validate() {
		let flag = true;
		return flag;
	}

	getRawValue() {
		return getRawValue(this);

		function getRawValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getRawValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getRawValue(obj[key][arrKey]));
						}
					} else {
						if (key != null) {
							value[key] = getRawValue(obj[key]);
						}
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			if (value == null) {
				console.log(obj);
			}
			return value;
		}
	}
	hasChanges() {
		// return !IsEqual(orgininalGlobalSettings.getValue(), this.getValue());
		return false;
	}
	revertChanges() {
		// this.constructor(orgininalGlobalSettings);
	}
	saveChanges() {
		// orgininalGlobalSettings = CloneDeep(this);
	}
}